import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "t" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "powerby" }, "技术支持：AffaMed Digital", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dv_decoration5 = _resolveComponent("dv-decoration5")!
  const _component_dv_decoration8 = _resolveComponent("dv-decoration8")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_dv_decoration5, {
      class: "t-b",
      dur: 5,
      style: {"width":"900px","height":"40px"}
    }),
    _createVNode(_component_dv_decoration8, {
      class: "t-l",
      style: {"width":"511px","height":"50px"}
    }),
    _createVNode(_component_dv_decoration8, {
      class: "t-r",
      reverse: true,
      style: {"width":"511px","height":"50px"}
    }),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.time), 1),
    _hoisted_4
  ]))
}